export default __webpack_public_path__ + "static/media/Netatmo_Rain_Gauge.b81ab554.png";